<template>
  <div class="home w-full px-36 py-8 float-left flex justify-center items-center">
    <!-- Done -->
    <div class="max-w-fix w-full flex flex-row float-left gap-14" style="max-width: 1248px">
      <div class="w-3/5 py-9 px-10 float-left shadow rounded-lg flex-grow">
        <div class="flex flex-col gap-4 w-full float-left">
          <div class="w-full float-left">
            <h1 class="text-lg font-medium text-black">
              {{ $t("place-order.title") }}
            </h1>
            <h2 class="text-sm text-gray">
              {{ $t("place-order.sub-title") }}
            </h2>
          </div>
          <div class="w-full float-left input">
            <label class="text-gray">{{ $t("place-order.time-date") }}</label>
            <TimeSelectInput @input="selectedTime = $event" :value="selectedTime" />
          </div>
          <div class="w-full float-left input">
            <label :class="modelErrors.pick_up_location_id
              ? 'text-primary-color'
              : 'text-gray'
              ">{{ $t("place-order.pickup") }}
              <span v-if="modelErrors.pick_up_location_id">{{ $t("errors.valid_pickup") }}</span></label>
            <GoogleMapsInput class="w-full" :placeholder="$t('place-order.select-pickup')"
              @inputSelected="pick_up_location_obj = $event" @validate="validate('pick_up_location_id')"
              :value="pick_up_location_obj" />
          </div>
          <div class="w-full float-left input">
            <label :class="modelErrors.pull_down_location_id
              ? 'text-primary-color'
              : 'text-gray'
              ">{{ $t("place-order.city") }}
              <span v-if="modelErrors.pull_down_location_id">{{ $t("errors.valid_destination") }}</span></label>
            <GoogleMapsInput class="w-full" :placeholder="$t('place-order.city')"
              @inputSelected="pull_down_location_obj = $event" @validate="validate('pull_down_location_id')"
              :value="pull_down_location_obj" />
          </div>

          <div class="w-full float-left input">
            <label class="text-gray">{{ $t("place-order.voucher") }}</label>
            <input name="voucher" type="text" autocomplete="off" v-model="model.voucher"
              :placeholder="$t('place-order.voucher')" />
          </div>
          <br />
          <div style="width:30%" class="float-left input">
            <div class="spring-spinner" v-if="servicesLoading">
              <div class="spring-spinner-part top">
                <div class="spring-spinner-rotator"></div>
              </div>
              <div class="spring-spinner-part bottom">
                <div class="spring-spinner-rotator"></div>
              </div>
            </div>
          </div>

          <div v-show="services.length > 0 && !servicesLoading" class="w-full float-left input">
            <label :class="modelErrors.service_id ? 'text-primary-color' : 'text-gray'
              ">{{ $t("place-order.services") }}
              <span v-if="modelErrors.service_id">{{ $t("errors.valid_service") }}</span></label>
            <RadioGroup :options="services" :value="selectedService" @selected_obj="selectedServiceObj = $event" />
          </div>

          <div class="w-full float-left">
            <button class="mt-8 float-right btn" @click="sendRequest" :disabled="sendingRequest">
              <div class="spring-spinner" v-if="sendingRequest">
                <div class="spring-spinner-part top">
                  <div class="spring-spinner-rotator"></div>
                </div>
                <div class="spring-spinner-part bottom">
                  <div class="spring-spinner-rotator"></div>
                </div>
              </div>
              <span v-else>
                {{ $t("place-order.send-orders") }}
              </span>
            </button>
          </div>
          <br />

        </div>
      </div>
      <div class="h-full rel flex flex-col gap-4 justify-start items-center sticky top-8" style="max-width: 400px">


        <div class="bg-white shadow rounded-lg flex-grow h-auto pt-6 pb-0 px-4" style="width: 400px; height: 602px">
          <Tabs ref="tabs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInput from "@/components/SelectInput.vue";
import TimeSelectInput from "@/components/TimeSelectInput.vue";
import RadioGroup from "@/components/RadioGroup.vue";
import CheckBoxesGroup from "@/components/CheckBoxesGroup.vue";
import Tabs from "@/components/Tabs.vue";
import GoogleMapsInput from "@/components/GoogleMapsInput.vue";

import * as yup from "yup";
import * as gjv from "geojson-validation";
import axios from "axios";
import moment from "moment";
import socketEventsMixin from "@/mixins/socketEventsMixin";
let CancelToken = axios.CancelToken;
var cancelRequest;

const modelSchema = yup.object().shape({
  service_id: yup.number().required(),
  pull_down_location_id: yup.number().required(),
  pick_up_location_id: yup.number().required(),

});

export default {
  name: "PlaceOrder",
  title: "Dashboard",
  mixins: [socketEventsMixin],
  events() {
    return {
      "Passengers:send_notification": this.notify,
      "Passengers:all_pending_bookings_count": this.allPendingBookingsCount,
      "Passengers:passenger_pending_bookings_count": this.passengerPendingBookingsCount,
      "Ride:captain_check": this.updateCounts,
      // "Passengers:card_payment_request": this.displayRequest,
    };
  },
  components: {
    SelectInput,
    TimeSelectInput,
    RadioGroup,
    CheckBoxesGroup,
    Tabs,
    GoogleMapsInput,
  },
  data() {
    const browserHost =
      window.location.hostname === "localhost"
        ? "127.0.0.1"
        : window.location.hostname;

    return {
      serverURL: process.env.VUE_APP_BACK || `http://${browserHost}:8000`,
      pick_up_location_obj: null,
      pull_down_location_obj: null,
      lastOrderError: null,
      dynamicConstraints: [],
      services: [],
      servicesLoading: false,
      model: {

        service_id: null,
        pick_up_location_id: null,
        pull_down_location_id: null,
        datetime: "ASAP",
        voucher: ""
      },
      modelErrors: {
        service_id: false,
        pick_up_location_id: false,
        pull_down_location_id: false
      },
      errors: {
        multipleOrders: false,
      },
      multipleOrders: false,
      multipleOrdersCount: 2,
      selectedTime: "ASAP",
      cities: [],
      selectedCity: {
        centroid: {},
      },
      cars: [],
      items: [],
      hotelOrRestaurantData: [],
      mandatory_details: false,
      seat_numbers: [
        { title: 1 },
        { title: 2 },
        { title: 3 },
        { title: 4 },
        { title: 5 },
        { title: 6 },
        { title: 7 },
      ],
      baggages_numbrer: [
        { title: 1 },
        { title: 2 },
        { title: 3 },
        { title: 4 },
        { title: 5 },
        { title: 6 },
        { title: 7 },
      ],
      langs: [],
      selectedCar: null,
      selectedService: "",
      selectedServiceObj: null,
      selectedCarObj: {},
      constraints: [],
      show_label: true,
      selectedConstraints: [],
      paymentMethods: [],
      selectedPaymentMethod: "",
      sendingRequest: false,
      allPendingBookings: 0,
      passengerPendingBookings: 0
    };
  },
  mounted() {

  },
  created() {
    this.loadData();
  },
  methods: {

    getHotelLastOrder() {

      if (this.selectedTime != "ASAP" && this.model.room_number != null) {
        const params = new URLSearchParams();
        params.append("room_number", this.model.room_number);
        params.append(
          "date",
          moment(this.selectedTime).format("Y-MM-DD HH:mm")
        );
        axios
          .get(this.$store.getters.getRootAPI + `get_hotel_last_order`, {
            params,
          })
          .then((res) => {

            this.lastOrderError = res.data.data;
          })
          .catch((error) => {
            // this.$notify({
            //   title: "Error",
            //   text: error.response.data.message,
            //   type: "error",
            // });
          });
      }
    },
    allPendingBookingsCount({ count }) {
      this.allPendingBookings = count;

    },
    passengerPendingBookingsCount({ count }) {
      this.passengerPendingBookings = count;

    },
    notify({ booking_id, message }) {
      console.log("notified");

      this.$notify({
        title: "Order transformed",
        text: message,
        type: "success",
      });
      close();
      console.log("notified");
    },
    validate(field) {
      if (field in this.model) {
        modelSchema
          .validateAt(field, this.model)
          .then(() => {
            this.modelErrors[field] = false;
          })
          .catch(() => {
            this.modelErrors[field] = true;
          });
      }
    },

    selectVehicleType(event) {
      this.modelErrors.vehicle_type_id = false;
      this.selectedCarObj = event;
      this.seat_numbers = [];
      for (var i = 1; i <= this.selectedCarObj.seats; i++) {
        this.seat_numbers.push({
          title: i,
        });
        this.model.seats = this.seat_numbers[0].title;
        this.model.number_of_baggages = this.baggages_numbrer[0].title;
      }


    },
    logout() {
      this.$store.dispatch("destroyToken").then(() => {
        this.$router.push({ name: "Login" });
      });
    },
    loadData() {
      // this.loadStats();
      // this.loadClusters();
      // this.loadStatusesCounts();
    },
    fixScroll(n, count = 0, changeBy = 1) {
      let target =
        target > scrollLeft
          ? document.getElementById(`${n}`).offsetLeft + 12
          : document.getElementById(`${n}`).offsetLeft - 12;
      // let target = document.getElementById(`${n}`).offsetLeft;
      let scrollLeft = this.$refs.counts.scrollLeft;
      this.$refs.counts.scrollLeft =
        target > scrollLeft ? scrollLeft + changeBy : scrollLeft - changeBy;
      let diff = Math.floor(Math.abs(this.$refs.counts.scrollLeft - target));
      if (count < diff) {
        window.requestAnimationFrame(() => {
          this.fixScroll(n, count + 1, count + 1);
        });
      }
    },
    getShortcutName(status) {
      switch (status) {
        case "IN_STATION":
          return "ST";
        case "IN_SERVICE":
          return "SV";
        case "FREE":
          return "LI";
        case "AT_DESTINATION":
          return "DE";
        case "BUSY":
          return "OC";
      }
    },
    loadStatusesCounts() {
      this.items = [];
      axios
        .get(this.$store.getters.getRootAPI + "statuses-counts")
        .then((res) => {
          res.data.data.forEach((item) => {
            let index = this.items.findIndex((obj) => {
              return obj.title === this.getShortcutName(item.status);
            });
            if (index >= 0) {
              this.items[index].vehicleCounts.push({
                name: item.name.charAt(0).toUpperCase() + item.name.slice(1),
                count: item.count,
              });
            } else {
              this.items.push({
                title: this.getShortcutName(item.status),
                count: item.status_count,
                vehicleCounts: [
                  {
                    name:
                      item.name.charAt(0).toUpperCase() + item.name.slice(1),
                    count: item.count,
                  },
                ],
              });
            }
          });
        });
    },

    updateCounts(data) {
      if (data.old_state !== data.state) {
        // get the in service index
        let inServiceIndex = this.items.findIndex((item) => {
          return item.title === "SV";
        });
        if (data.old_state === "UNAVAILABLE") {
          if (inServiceIndex >= 0) {
            this.items[inServiceIndex].count++;
            let vehicleIndex = this.items[
              inServiceIndex
            ].vehicleCounts.findIndex((item) => {
              return item.name.toLowerCase() == data.vehicle_name.toLowerCase();
            });
            if (vehicleIndex >= 0) {
              this.items[inServiceIndex].vehicleCounts[vehicleIndex].count++;
            } else {
              this.items[inServiceIndex].vehicleCounts.push({
                name:
                  data.vehicle_name.charAt(0).toUpperCase() +
                  data.vehicle_name.slice(1),
                count: 1,
              });
            }
          } else {
            this.items.push({
              title: "SV",
              count: 1,
              vehicleCounts: [
                {
                  name:
                    data.vehicle_name.charAt(0).toUpperCase() +
                    data.vehicle_name.slice(1),
                  count: 1,
                },
              ],
            });
          }
        } else if (data.state === "UNAVAILABLE" && inServiceIndex >= 0) {
          this.items[inServiceIndex].count--;
          let vehicleIndex = this.items[inServiceIndex].vehicleCounts.findIndex(
            (item) => {
              return item.name.toLowerCase() == data.vehicle_name.toLowerCase();
            }
          );
          if (vehicleIndex >= 0) {
            this.items[inServiceIndex].vehicleCounts[vehicleIndex].count--;
          }
          if (
            this.items[inServiceIndex].vehicleCounts[vehicleIndex].count == 0
          ) {
            this.items.splice(inServiceIndex, 1);
          }
        }
        let index = null;
        // increase the count
        if (data.state !== "UNAVAILABLE") {
          index = this.items.findIndex((item) => {
            return item.title === this.getShortcutName(data.state);
          });
          if (index >= 0) {
            this.items[index].count++;
            let vehicleIndex = this.items[index].vehicleCounts.findIndex(
              (item) => {
                return (
                  item.name.toLowerCase() == data.vehicle_name.toLowerCase()
                );
              }
            );
            if (vehicleIndex >= 0) {
              this.items[index].vehicleCounts[vehicleIndex].count++;
            } else {
              this.items[index].vehicleCounts.push({
                name:
                  data.vehicle_name.charAt(0).toUpperCase() +
                  data.vehicle_name.slice(1),
                count: 1,
              });
            }
          } else {
            this.items.push({
              title: this.getShortcutName(data.state),
              count: 1,
              vehicleCounts: [
                {
                  name:
                    data.vehicle_name.charAt(0).toUpperCase() +
                    data.vehicle_name.slice(1),
                  count: 1,
                },
              ],
            });
          }
        }
        // decrease the count
        index = this.items.findIndex((item) => {
          return item.title == this.getShortcutName(data.old_state);
        });
        if (index >= 0) {
          this.items[index].count--;
          let vehicleIndex = this.items[index].vehicleCounts.findIndex(
            (item) => {
              return item.name.toLowerCase() == data.vehicle_name.toLowerCase();
            }
          );
          if (vehicleIndex >= 0) {
            this.items[index].vehicleCounts[vehicleIndex].count--;
            if (this.items[index].vehicleCounts[vehicleIndex].count <= 0) {
              this.items[index].vehicleCounts.splice(vehicleIndex, 1);
            }
          }
          if (
            this.items[index].vehicleCounts.length == 0 ||
            this.items[index].count == 0
          ) {
            this.items.splice(index, 1);
          }
        }
      }
    },

    loadStats() {
      axios
        .get(this.$store.getters.getRootAPI + "booking-stats")
        .then((response) => {

          this.allPendingBookings = response.data.data.pendingBookings;
          this.passengerPendingBookings = response.data.data.passengerPendingBookings;
        })
        .catch((error) => {
          console.log(error);
        });

    },
    loadServices() {
      if (!this.model.pick_up_location_id || !this.model.pull_down_location_id) {
        return;
      }

      let data = {
        "pickup": this.model.pick_up_location_id,
        "destination": this.model.pull_down_location_id,

      };
      if (this.model.voucher)
        data.voucher = this.model.voucher;
      if (this.model.datetime != "ASAP")
        data.time = this.model.datetime;
      this.servicesLoading = true;

      if (cancelRequest) cancelRequest();
      axios
        .post(this.$store.getters.getRootAPI + "services", data,
          {
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
            }),
          })
        .then((response) => {
          this.services = [];

          response.data.data.services.forEach((item) => {
            this.services.push({
              id: item.id,
              title: item.name_en,
              img: this.serverURL + item.icon
            });

            if (!this.selectedService) {
              this.selectedService = this.services[0].title;
              this.selectedServiceObj = this.services[0];
            }

          });
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "Error",
            text: error.response.data.message || "Can't load srvices",
            type: "error",
          });
          this.services = [];
          this.selectedService = "";
          this.selectedServiceObj = null;
        })
        .finally(() => {
          this.servicesLoading = false;
        });

    },
    loadClusters() {
      axios
        .get(this.$store.getters.getRootAPI + "location_cluster")
        .then((response) => {
          this.cities = [];
          response.data.data.data.forEach((item) => {
            this.cities.push({
              id: item.id,
              title: item.title,
              centroid: item.centroid,
              type: item.type,
              far_city: item.far_city ? item.far_city : 0,
              is_favorite: item.favorites_clusters.length !== 0 ? true : false,
            });
          });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },


    formData() {
      console.log("formData", this.model)
      if (this.model.datetime == "ASAP")
        delete this.model.datetime;

      if (!this.model.voucher)
        delete this.model.voucher;

    },
    validateAllData() {
      this.formData();
      Object.keys(this.modelErrors).forEach((key) => {
        this.validate(key);
      });
      console.log(this.modelErrors)
      console.log(this.model)
    },

    async sendRequest() {
      await this.validateAllData();
      console.log("err", this.modelErrors)
      if (!this.model.service_id || !this.model.pick_up_location_id || !this.model.pull_down_location_id) {
        this.$notify({
          title: this.$t("errors.title"),
          text: this.$t("errors.invalid_order"),
          type: "error",
        });
        return;
      }
      if (!Object.values(this.modelErrors).includes(true)) {
        if (this.$store.getters.loggedIn && !this.sendingRequest) {


          this.sendingRequest = true;

          axios
            .post(this.$store.getters.getRootAPI + "booking", this.model)
            .then((response) => {
              this.$notify({
                title: "Done",
                text: "Order sent successfully",
                type: "success",
              });
              this.services = [];
              this.pick_up_location_obj = null;
              this.pull_down_location_obj = null;
              this.selectedTime = "ASAP";

              this.selectedService = "";
              this.selectedServiceObj = null;

              this.model.service_id = null;
              this.model.voucher = "";

              this.loadData();
            })
            .catch((error) => {
              this.$notify({
                title: "Error",
                text: error.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.sendingRequest = false;
              window.scrollTo(0, 0);
            });
        } else if (!this.$store.getters.loggedIn) {
          this.$notify({
          title: this.$t("errors.title"),
          text: this.$t("errors.not_logged_in"),
          type: "error",
        });
          this.$router.push({ name: "Login" });
        }
      } else {
        window.scrollTo(0, 0);
       this.$notify({
          title: this.$t("errors.title"),
          text: this.$t("errors.invalid_order"),
          type: "error",
        });
      }
    },
  },
  watch: {

    pick_up_location_obj: function (newVal) {
      if (newVal)
        this.model.pick_up_location_id = newVal.id;
      else
        this.model.pick_up_location_id = null;
      this.loadServices()
    },
    pull_down_location_obj: function (newVal) {
      if (newVal)
        this.model.pull_down_location_id = newVal.id;
      else
        this.model.pull_down_location_id = null;
      this.loadServices()
    },
    "model.voucher": function (newVal) {
      console.log(this.model)
      this.loadServices()
    },
    selectedServiceObj: function (newVal) {
      if (newVal && newVal.id)
        this.model.service_id = newVal.id;
      else
        this.model.service_id = null;
    },
    selectedTime: function (newVal) {
      if (newVal !== "ASAP")
        this.model.datetime = moment(this.selectedTime).format("Y-MM-DD HH:mm");
      else
        this.model.datetime = "ASAP";
      this.loadServices()
    },
    items: {
      handler: function (newVal) {
        let count = 0;
        newVal.forEach((i) => {
          if (i.title !== "SV") count += i.count;
        });
        let svIndex = this.items.findIndex((item) => {
          return item.title === "SV";
        });
        if (svIndex >= 0 && count != this.items[svIndex].count) {
          this.loadStatusesCounts();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  label {
    text-align: left;
    float: left;
    font-size: 14px;
    padding-bottom: 6px;
    width: 100%;

    span {
      float: right;
      text-align: right;
    }
  }

  input {
    float: left;
    width: 100%;
    max-width: none;

    &[type="checkbox"] {
      width: 12px;
      height: 12px;
      float: left;
      margin-right: 4px;
      margin-top: 4px;
    }

    &.error-border {
      border: 1px solid;
    }
  }
}

.btn {
  width: 200px;
  max-width: 400px;
  border-radius: 5px;
}

button {
  max-width: 200px;
  max-height: 40px;

  span {
    color: white !important;
    width: 100%;
    text-align: center;
  }
}

.item {
  height: 100%;
  border-radius: 0.5rem;
  position: relative;
  background: white;
  float: left;
  width: 70px;
  overflow: hidden;
  cursor: pointer;
  transition: 0.4s;
  flex-grow: 0;
  flex-shrink: 0;

  &.zero-width {
    width: 0px;
  }

  &.hidden {
    display: none;
  }

  &:hover {
    width: 230px;

    .item-container {
      .item-content:first-child {
        background-color: #f3f3f3;
      }
    }
  }

  .vehicle-counts {
    float: left;
    height: 100%;
    padding: 6px;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 33.3% 33.3% 33.3%;
    width: 160px;
    cursor: default;
    background: white;

    div {
      padding: 4px;
      overflow: hidden;
      width: 100%;

      label:first-child {
        font-weight: 600;
      }

      label {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .item-container {
    position: absolute;
    left: 0;
    top: 0;
    float: left;
    display: flex;
    justify-content: flex-start;
    height: 100%;

    .item-content {
      float: left;
      height: 100%;
      padding: 24px;
      width: 70px;
      text-align: center;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      flex-direction: column;
      transition: 0.2s;

      h2 {
        font-size: 12pt;
        line-height: 16pt;
        max-width: 100%;
        // word-break: break-word;
      }

      label {
        font-size: 18pt;
        line-height: 24pt;
        max-width: 100%;
      }
    }
  }
}
</style>
